"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetContentItemsV2Impl = void 0;
var HttpError_1 = require("../model/HttpError");
/**
 * Utility that maps an array of ids or keys into the expected format of a `content/fetch` request body
 * @param property id or key
 * @param values array of ids or keys
 * @hidden
 */
function mapToRequests(property, values) {
    if (!Array.isArray(values)) {
        throw new TypeError('Expecting an array');
    }
    return values.map(function (value) {
        var _a;
        return (_a = {}, _a[property] = String(value), _a);
    });
}
/**
 * Wraps `content/fetch`
 * @hidden
 */
var GetContentItemsV2Impl = /** @class */ (function () {
    function GetContentItemsV2Impl(config, contentClient) {
        this.config = config;
        this.contentClient = contentClient;
    }
    GetContentItemsV2Impl.prototype.getContentItemsByKey = function (keys) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContentItems(mapToRequests('key', keys))];
            });
        });
    };
    GetContentItemsV2Impl.prototype.getContentItemsById = function (ids) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getContentItems(mapToRequests('id', ids))];
            });
        });
    };
    GetContentItemsV2Impl.prototype.getContentItems = function (requests, parameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchContentItems({
                        parameters: parameters,
                        requests: requests,
                    })];
            });
        });
    };
    GetContentItemsV2Impl.prototype.fetchContentItems = function (_a) {
        var requests = _a.requests, parameters = _a.parameters;
        return __awaiter(this, void 0, void 0, function () {
            var defaultParameters, mergedParameters, data, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        defaultParameters = {
                            depth: 'all',
                            format: 'inlined',
                        };
                        if (this.config.locale) {
                            defaultParameters.locale = this.config.locale;
                        }
                        mergedParameters = __assign(__assign({}, defaultParameters), (parameters || {}));
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.contentClient.post('content/fetch', {
                                parameters: mergedParameters,
                                requests: requests,
                            })];
                    case 2:
                        data = (_b.sent()).data;
                        return [2 /*return*/, data];
                    case 3:
                        err_1 = _b.sent();
                        if (err_1.response) {
                            throw new HttpError_1.HttpError(err_1.response.status, err_1.response.data);
                        }
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return GetContentItemsV2Impl;
}());
exports.GetContentItemsV2Impl = GetContentItemsV2Impl;
//# sourceMappingURL=data:application/json;base64,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